const flexible = [
  { name: 'flexible-1', calories: 475, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-2', calories: 500, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-3', calories: 525, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-4', calories: 550, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-5', calories: 575, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-6', calories: 600, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-7', calories: 625, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-8', calories: 650, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-9', calories: 675, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-10', calories: 700, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-11', calories: 725, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-12', calories: 750, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-13', calories: 775, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-14', calories: 800, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-15', calories: 825, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-16', calories: 850, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-17', calories: 875, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-18', calories: 900, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-19', calories: 925, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-20', calories: 950, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-21', calories: 975, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-22', calories: 1000, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-23', calories: 1025, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-24', calories: 1050, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-25', calories: 1100, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-26', calories: 1125, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-27', calories: 1150, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-28', calories: 1175, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-29', calories: 1200, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-30', calories: 1225, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-31', calories: 1250, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-32', calories: 1275, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-33', calories: 1300, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-34', calories: 1325, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-35', calories: 1350, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-36', calories: 1375, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-37', calories: 1400, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-38', calories: 1425, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-39', calories: 1450, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-40', calories: 1475, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-41', calories: 1500, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-42', calories: 1525, protein: 50, fat: 50, carbs: 50 },
  { name: 'flexible-43', calories: 1550, protein: 50, fat: 50, carbs: 50 }
]

const lowCarb = [
  { name: 'lowcarb-1', calories: 475, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-2', calories: 500, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-3', calories: 525, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-4', calories: 550, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-5', calories: 575, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-6', calories: 600, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-7', calories: 625, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-8', calories: 650, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-9', calories: 675, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-10', calories: 700, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-11', calories: 725, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-12', calories: 750, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-13', calories: 775, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-14', calories: 800, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-15', calories: 825, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-16', calories: 850, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-17', calories: 875, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-18', calories: 900, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-19', calories: 925, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-20', calories: 950, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-21', calories: 975, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-22', calories: 1000, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-23', calories: 1025, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-24', calories: 1050, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-25', calories: 1100, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-26', calories: 1125, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-27', calories: 1150, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-28', calories: 1175, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-29', calories: 1200, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-30', calories: 1225, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-31', calories: 1250, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-32', calories: 1275, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-33', calories: 1300, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-34', calories: 1325, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-35', calories: 1350, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-36', calories: 1375, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-37', calories: 1400, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-38', calories: 1425, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-39', calories: 1450, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-40', calories: 1475, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-41', calories: 1500, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-42', calories: 1525, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowcarb-43', calories: 1550, protein: 50, fat: 50, carbs: 50 }
]

const lowFat = [
  { name: 'lowfat-1', calories: 475, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-2', calories: 500, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-3', calories: 525, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-4', calories: 550, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-5', calories: 575, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-6', calories: 600, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-7', calories: 625, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-8', calories: 650, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-9', calories: 675, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-10', calories: 700, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-11', calories: 725, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-12', calories: 750, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-13', calories: 775, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-14', calories: 800, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-15', calories: 825, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-16', calories: 850, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-17', calories: 875, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-18', calories: 900, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-19', calories: 925, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-20', calories: 950, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-21', calories: 975, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-22', calories: 1000, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-23', calories: 1025, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-24', calories: 1050, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-25', calories: 1100, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-26', calories: 1125, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-27', calories: 1150, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-28', calories: 1175, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-29', calories: 1200, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-30', calories: 1225, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-31', calories: 1250, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-32', calories: 1275, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-33', calories: 1300, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-34', calories: 1325, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-35', calories: 1350, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-36', calories: 1375, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-37', calories: 1400, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-38', calories: 1425, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-39', calories: 1450, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-40', calories: 1475, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-41', calories: 1500, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-42', calories: 1525, protein: 50, fat: 50, carbs: 50 },
  { name: 'lowfat-43', calories: 1550, protein: 50, fat: 50, carbs: 50 }
]

const ketogenic = [
  { name: 'ketogenic-1', calories: 475, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-2', calories: 500, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-3', calories: 525, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-4', calories: 550, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-5', calories: 575, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-6', calories: 600, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-7', calories: 625, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-8', calories: 650, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-9', calories: 675, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-10', calories: 700, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-11', calories: 725, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-12', calories: 750, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-13', calories: 775, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-14', calories: 800, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-15', calories: 825, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-16', calories: 850, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-17', calories: 875, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-18', calories: 900, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-19', calories: 925, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-20', calories: 950, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-21', calories: 975, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-22', calories: 1000, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-23', calories: 1025, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-24', calories: 1050, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-25', calories: 1100, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-26', calories: 1125, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-27', calories: 1150, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-28', calories: 1175, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-29', calories: 1200, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-30', calories: 1225, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-31', calories: 1250, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-32', calories: 1275, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-33', calories: 1300, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-34', calories: 1325, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-35', calories: 1350, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-36', calories: 1375, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-37', calories: 1400, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-38', calories: 1425, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-39', calories: 1450, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-40', calories: 1475, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-41', calories: 1500, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-42', calories: 1525, protein: 50, fat: 50, carbs: 50 },
  { name: 'ketogenic-43', calories: 1550, protein: 50, fat: 50, carbs: 50 }
]

export { flexible, lowCarb, lowFat, ketogenic }
